import React, { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';

export interface Props extends ReactDatePickerProps {
  classNames?: string;
}

const DatePicker = (ReactDatePicker as unknown as { default: typeof ReactDatePicker }).default ?? ReactDatePicker;

const TimePickerInput = forwardRef<
  HTMLButtonElement,
  DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement> & { placeholder?: string },
    HTMLButtonElement
  >
>(({ placeholder, value, ...rest }, ref) => (
  <button ref={ref} type='button' {...rest}>
    <span className='flex-1 text-left truncate'>{value || placeholder}</span>
    <FontAwesomeIcon icon={faChevronDown} className='ml-2 text-gray-400' />
  </button>
));

TimePickerInput.displayName = 'TimePickerInput';

const timeIntervalMinutesDefault = 15;
const timeFormatDefault = 'h:mm aa';
const timePickerClasses = 'flex items-center p-2 w-36 h-10 ml-[5px] border-[1px] border-gray-400 outline-none rounded-md focus:border-sapphire focus:outline-none focus:ring-0 focus:ring-offset-0';

export const TimePicker = (props: Props): JSX.Element => {
  const { classNames, timeIntervals = timeIntervalMinutesDefault, dateFormat = timeFormatDefault, ...rest } = props;

  return (
    <div className='relative shrink-0 w-36'>
      <DatePicker
        {...rest}
        className={`${timePickerClasses}${classNames ? ` ${classNames}` : ''}`}
        customInput={<TimePickerInput />}
        popperClassName='z-50'
        showTimeSelectOnly
        showTimeSelect
        timeIntervals={timeIntervals}
        dateFormat={dateFormat}
      />
    </div>
  );
};
